import React, { useState } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css"; // default styling
import "../css/calendar.css";
import { events } from "../Data";
function CalendarEvent() {
  const [dates, setDates] = useState([
    "2024-08-12",
    "2024-08-15",
    "2024-08-21",
    "2024-08-23",
  ]);

  // Filter out past events
  const today = new Date();
  const upcomingEvents = events.filter(
    (event) => new Date(event.date) >= today
  );

  // Convert event dates to Date objects for easier comparison
  const formattedDates = upcomingEvents.map((event) => ({
    ...event,
    dateObj: new Date(event.date),
  }));

  // Determine the next upcoming event's month
  const nextEvent = formattedDates[0]?.dateObj || today;

  return (
    <div className="relative">
      <Calendar
        // Set the initial view to the next upcoming event's month
        defaultActiveStartDate={
          new Date(nextEvent.getFullYear(), nextEvent.getMonth())
        }
        showNeighboringCentury={false}
        showNeighboringDecade={false}
        onClickYear={null}
        prev2Label={null}
        next2Label={null}
        tileClassName={({ date, view }) => {
          if (
            view === "month" &&
            formattedDates.find(
              (event) =>
                event.dateObj.getFullYear() === date.getFullYear() &&
                event.dateObj.getMonth() === date.getMonth() &&
                event.dateObj.getDate() === date.getDate()
            )
          ) {
            return " highlighted-date"; // Tailwind highlight styles
          }
          return null;
        }}
        tileContent={({ date, view }) => {
          const event = formattedDates.find(
            (e) =>
              e.dateObj.getFullYear() === date.getFullYear() &&
              e.dateObj.getMonth() === date.getMonth() &&
              e.dateObj.getDate() === date.getDate()
          );
          return event && view === "month" ? (
            <div className="absolute">
              <div className="tooltip">Event on {event.title}</div>
            </div>
          ) : null;
        }}
      />
    </div>
  );
}

export default CalendarEvent;
